import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

export const withRouter = <ComponentProps,>(Component: React.ComponentType<ComponentProps>) => {
  const ComponentWithRouterProp = (props: ComponentProps) => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

    return <Component {...props} location={location} navigate={navigate} params={params} />
  }

  return ComponentWithRouterProp
}
